<ng-container *ngIf="profileError">
    <div class="container py-4">
        <div class="alert alert-warning mb-0">{{ profileError }}</div>
    </div>
</ng-container>

<ng-container *ngIf="!profileError && !profileLoaded">
    <div class="container py-4 text-muted">Loading profile {{ '@' + previewAccountHandle }}…</div>
</ng-container>

<ng-container *ngIf="profileLoaded && !profileError">
    <div class="ts-dashboard-shell">
        <div class="ts-dashboard-center-track">
            <div class="ts-dashboard-cluster g-0">
                <aside class="col-auto ts-rail-left left_sidebar ts-rail-column border-end d-none d-md-flex flex-column px-0 align-items-stretch"
                       aria-label="Main navigation">
                    <app-left-sidebar class="ts-sidebar-host"
                                      [Username]="Username"
                                      [UserID]="UserID"
                                      (postSubmitComplete)="onPostEditedOrDeleted()"
                                      (postContent)="updatePostContent($event)"
                                      (mediaUrlsChange)="updatePostMediaUrls($event)"
                                      (replyTypeChange)="updateReplyType($event)"
                                      (onSave)="savePost()">
                    </app-left-sidebar>
                </aside>

                <div class="ts-dashboard-gutter ts-dashboard-gutter--start d-none d-md-block flex-shrink-0"
                     aria-hidden="true"></div>

                <div class="px-0 main_bar ts-main-feed-themed ts-dashboard-main">
                    <header class="ts-sticky-feed-header">
                        <div class="ts-feed-tabs">
                            <button type="button"
                                    [class.ts-feed-tab-active]="feedTab === 'foryou'"
                                    (click)="setFeedTab('foryou')">
                                For You
                            </button>
                            <button type="button"
                                    [class.ts-feed-tab-active]="feedTab === 'following'"
                                    (click)="setFeedTab('following')">
                                Following
                            </button>
                        </div>
                    </header>

                    <section class="ts-composer-section border-bottom">
                        <p class="text-muted small px-2 mb-2">
                            Preview: latest {{ pageSize }} posts from {{ '@' + previewAccountHandle }} (live API).
                        </p>
                        <div class="ts-composer-inner">
                            <div class="ts-composer-avatar user-avatar-container-top">
                                <img [src]="'api/content/logo?userID=' + UserID"
                                     (error)="onApiLogoError($event)"
                                     alt="">
                            </div>
                            <div class="ts-composer-body">
                                <app-post-submit [Username]="Username"
                                                 [UserID]="UserID"
                                                 [pageType]="'postSubmitModal'"
                                                 [mediaUrls]="mediaUrls"
                                                 [selectedReplyType]="selectedReplyType"
                                                 (postContent)="updatePostContent($event)"
                                                 (removeMedia)="removeMediaFromFooter($event)">
                                </app-post-submit>
                                <app-post-footer #footerComponent
                                                 [Username]="Username"
                                                 [UserID]="UserID"
                                                 [hasPostText]="hasPostText"
                                                 [pageType]="'Home'"
                                                 (mediaUrlsChange)="updatePostMediaUrls($event)"
                                                 (replyTypeChange)="updateReplyType($event)"
                                                 (onSave)="savePost()">
                                </app-post-footer>
                            </div>
                        </div>
                    </section>

                    <div class="row g-0 mt-4">
                        <div class="col pt-2">
                            <div *ngIf="postsLoading" class="py-3 text-muted ps-1">Loading posts…</div>
                            <div *ngIf="!postsLoading && postsError" class="alert alert-warning">{{ postsError }}</div>
                            <div *ngIf="!postsLoading && !postsError && UserPostsData.length === 0" class="py-3 text-muted ps-1">
                                No posts returned for this account.
                            </div>

                            <div *ngIf="!postsLoading && !postsError && UserPostsData.length > 0">
                                <div *ngFor="let postData of UserPostsData; let i = index">
                                    <div [id]="'post' + ((currentPage - 1) * pageSize + i)"
                                         class="post-container"
                                         (click)="navigateToPost(postData.UserName, postData.TSID)">
                                        <app-post-detail (postEditedOrDeleted)="onPostEditedOrDeleted()"
                                                         [Username]="Username"
                                                         [UserID]="UserID"
                                                         [postData]="postData"
                                                         [pageType]="'dashboard'">
                                        </app-post-detail>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="ts-dashboard-gutter ts-dashboard-gutter--end flex-shrink-0"
                     aria-hidden="true"></div>

                <aside class="col-auto ts-rail-right ts-rail-right--dashboard ts-rail-column right_side_bar flex-column px-0 align-items-stretch"
                       aria-label="Search and suggestions">
                    <div class="sidebar-content flex-grow-1">
                        <app-right-sidebar [Username]="Username"
                                           [UserID]="UserID">
                        </app-right-sidebar>
                    </div>
                </aside>
            </div>
        </div>
    </div>
</ng-container>
